import Menubar from './Menubar';

export default Menubar;
